import { queryOptions, skipToken } from "@tanstack/react-query";
import type { FindFeedInput } from "@wags/discovery/index.ts";
import { FIND_FEED_QUERY_PREFIX } from "@/features/discovery";
import { FIND_FEED_RETRY_OPTIONS } from "../find/find-load-failure";
import {
    type FindFeedBundledResponse,
    getFindFeedWithCompatibilityScores,
} from "./find-feed";

export const FIND_FEED_QUERY_LIMIT_PER_ROW = 6;

async function fetchFindFeedQuery(
    input: FindFeedInput,
): Promise<FindFeedBundledResponse> {
    return await getFindFeedWithCompatibilityScores({ data: input });
}

export function findFeedQueryInput(location: {
    lat: number;
    lng: number;
}): FindFeedInput {
    return {
        lat: location.lat,
        lng: location.lng,
        limitPerRow: FIND_FEED_QUERY_LIMIT_PER_ROW,
    };
}

export function getFindFeedQueryOptions(input: FindFeedInput | null) {
    return queryOptions({
        queryKey: [...FIND_FEED_QUERY_PREFIX, input] as const,
        queryFn: input ? () => fetchFindFeedQuery(input) : skipToken,
        staleTime: 60_000,
        ...FIND_FEED_RETRY_OPTIONS,
    });
}
